'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _debugActions = require('./debugActions');

require('./DebugTool.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions
// Lib
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        toggleDebugTool: function toggleDebugTool(enabled) {
            return function () {
                dispatch((0, _debugActions.toggleDebugTool)({ enabled: enabled, toolName: ownProps.toolName }));

                ownProps.onClickFn && ownProps.onClickFn(enabled);
            };
        }
    };
};

// Styles


var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        toolEnabled: state.getIn(['debug', ownProps.toolName, 'enabled'])
    };
};

var DebugTool = function DebugTool(props) {
    var toolEnabled = props.toolEnabled;


    var classes = (0, _classnames2.default)('DebugTool', {
        active: toolEnabled
    });

    return _react2.default.createElement(
        'div',
        { className: classes, onClick: props.toggleDebugTool(!toolEnabled) },
        props.children
    );
};

DebugTool.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    toggleDebugTool: _propTypes2.default.func,
    onClickFn: _propTypes2.default.func,
    toolEnabled: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DebugTool);


//////////////////
// WEBPACK FOOTER
// ./src/client/debug/DebugTool.js
// module id = 1935
// module chunks = 0